import { urlKey } from "../../../../services/api/api-urls";
import { getColModelItem } from "../../../../services/lib/utils/helpers";

export default class ProductBarcodeManagementColumnModel {
	static Column = [
		{
			...getColModelItem({
				title: 'Product Name',
				field: 'productId',
				keywords: [
					urlKey.Product
				]
			}, () => ([{ key: urlKey.Product, label: '', 
						otherOptions: 
						{ type: 'select', isOverrideSelectionOptions: true, selectionGetUrl: '/Product/GetAllProductName', width: '14rem', valueJoinArray: ['productName', 'productCode'] } }])),
			// Table cell shows name only; code is shown in its own column
			render: (rowData: any) => rowData.product?.productName || rowData.productName || ''
		},
		{
			title: 'Product Code',
			align: 'left',
			field: 'product.productCode',
			editable: 'never',
			render: (rowData: any) => rowData.product?.productCode || rowData.productCode || '',
			customFilterAndSearch: (filter: any, rowData: any) =>
				(rowData.product?.productCode || rowData.productCode || '').toString().toLowerCase().includes(filter.toString().toLowerCase())
		},
		{
			title: 'Barcode',
			align: 'left',
			field: 'barcode'
		},

	]
}
